module.exports = {
	"author": "cmessud",
	"authorTitle": "Claire Messud",
	"facebook": "fa fa-facebook-official",
	"instagram": "fa fa-instagram",
	"twitter": "fa fa-twitter",
	"youtube": "fa fa-youtube-play",
	"serviceRoot": "https://services.wwnorton.com/getCmsContent.php?url=/api/author/",
	"stylesheet": "./cmessud.css",
	"instagramAPIKey": "KEY",
	"youtubeAPIKey": "KEY",
	"google": "GA-KEY",
	"books": [
		{
			"title": "the-hunters",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/the-hunters-9780393541816/9780393541816",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "the-burning-girl",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/the-burning-girl-9780393356052/9780393356052",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "the-woman-upstairs",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/the-woman-upstairs/9780307743763 ",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "when-the-world-was-steady",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/when-the-world-was-steady/9780393355093",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "kant-s-little-prussian-head-and-other-reasons-why-i-write",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/kant-s-little-prussian-head-and-other-reasons-why-i-write-an-autobiography-in-essays/9781324006756",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "the-emperor-s-children",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/the-emperor-s-children/9780307276667",
					"retailer": "Bookshop"
				}
			]
		},
		{
			"title": "the-last-life",
			"retailersLinks": [
				{
					"link": "https://bookshop.org/books/the-last-life/9780156011655",
					"retailer": "Bookshop"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 20
// module chunks = 0